import { Moment } from 'moment'

import { IActivity } from '../../App/store/features/activity/interface/IActivityList'
import { Person } from '../../App/store/features/person/IPerson'
import { findActivityUuid } from '../EventCrudPanel/Appointment/UpdateAppointment/utils/findUuid/findActivityUuid'
import {
  IAppointment,
  IAppointmentActivity,
  IAppointmentFormSubmission,
  IPostActivity,
} from '../types'

export const transformPasteToCreateAppointment = (
  appointment: IAppointment,
  clickedMoment: Moment,
  person: Person,
  activityList: IActivity[],
): IAppointmentFormSubmission => {
  const transformAppointmentActivities = (
    appointmentActivities: IAppointmentActivity[],
  ): IPostActivity[] =>
    appointmentActivities.map(activity => ({
      activityUuid: findActivityUuid(activityList, activity.activityId),
      isLocked: activity.isLocked,
      personUuids: [person.personUuid],
    }))

  return {
    customerUuid: appointment.customer.uuid,
    startsAt: clickedMoment,
    appointmentActivities: transformAppointmentActivities(
      appointment.appointmentActivity,
    ),
    isRepeat: false,
    repeatWeekInterval: 0,
    repeatStopsAt: undefined,
    repeatStopsAfter: 0,
    repeatOption: 'never',
    notes: appointment.appointmentNotes,
    startHour: clickedMoment.clone().format('HH:mm'),
  }
}
